// @ts-nocheck
import React from "react";
import ContentLoader, { Rect } from "react-content-loader";

const PostSkeleton = (props) => (
  <ContentLoader
    speed={2}
    width={400}
    height={160}
    viewBox="0 0 400 160"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    <rect x="48" y="8" rx="3" ry="3" width="88" height="6" />
    <rect x="48" y="26" rx="3" ry="3" width="52" height="6" />
    <rect x="0" y="56" rx="3" ry="3" width="410" height="6" />
    <rect x="0" y="72" rx="3" ry="3" width="380" height="6" />
    <rect x="0" y="88" rx="3" ry="3" width="178" height="6" />
    <circle cx="20" cy="20" r="20" />
  </ContentLoader>
);

const PostListLoader: React.FC = () => {
  return (
    <div className="mt-2 py-2 bg-white pb-10">
      {[1, 2, 3, 4].map((item) => (
        <div
          key={item}
          className="mb-5 pt-2 border-b border-gray-200 px-4 pb-4 last:border-none"
        >
          <PostSkeleton />
        </div>
      ))}
    </div>
  );
};

export default PostListLoader;
